import {Component, OnInit, OnChanges, Output, EventEmitter, Input, SimpleChanges} from '@angular/core';
import {NgModel} from '@angular/forms';
import * as moment1 from 'moment';
import {extendMoment} from 'moment-range';

const moment = extendMoment(moment1);

import {UtilsService} from '../../core/utils/utils.service';

@Component({
  selector: 'app-dashboard-filtros',
  templateUrl: './dashboard-filtros.component.html'
})

export class DashboardFiltrosComponent implements OnInit, OnChanges {
  selectedAnos = [moment().year()];
  selectedMeses = [moment().month() + 1];
  meses = [];
  anos = [];
  selectedMin = 1;
  selectedMax;
  dataMinLabel = '';
  dataMaxLabel = '';
  rangeDays;
  @Input() dataInicial;
  @Input() dataFinal = 'now';
  @Output() changeFilter = new EventEmitter<{}>();

  constructor(private _utilsService: UtilsService) {
  }

  calcSliderRange(dataInicial, dataFinal) {
    const dtFinal = this.getDataFinal(dataFinal);
    this.selectedMax = moment(dtFinal).diff(this.dataInicial, 'days') + 1;
    this.rangeDays = this._utilsService.rangeArray(dataInicial, dtFinal, 'days', 'DD/MM/YYYY');
    this.calcRangeDate(this.selectedMin, this.selectedMax);
  }

  getDataFinal(dataFinal) {
    switch (dataFinal) {
      case 'now':
        return moment().format('YYYY/MM/DD');
      case 'end month':
        return moment().endOf('month').format('YYYY/MM/DD');
      default:
        return moment(dataFinal).format('YYYY/MM/DD');
    }
  }

  calcRangeDate(selectedMin, selectedMax) {
    const x = moment(this.rangeDays[selectedMin - 1], 'DD/MM/YYYY').format('YYYY/MM/DD');
    const y = moment(this.rangeDays[selectedMax - 1], 'DD/MM/YYYY').format('YYYY/MM/DD');
    this.meses = this._utilsService.rangeArray(moment(x).startOf('month'), moment(y).endOf('month'), 'month', 'M');
    this.selectedMeses = this.meses;
    this.anos = this._utilsService.rangeArray(moment(x).startOf('year'), moment(y).endOf('year'), 'year', 'YYYY');
    this.selectedAnos = this.anos;
    this.emitFilter();
  }

  emitFilter() {
    this.changeFilter.emit({
      dataInicial: moment(this.rangeDays[this.selectedMin - 1], 'DD-MM-YYYY').format('YYYY-MM-DD'),
      dataFinal: moment(this.rangeDays[this.selectedMax - 1], 'DD-MM-YYYY').format('YYYY-MM-DD'),
      meses: this.selectedMeses,
      anos: this.selectedAnos
    });
  }

  equals(objOne, objTwo) {
    if (typeof objOne !== 'undefined' && typeof objTwo !== 'undefined') {
      return objOne === objTwo;
    }
  }

  selectAll(select: NgModel, values) {
    select.update.emit(values);
    this.emitFilter();
  }

  deselectAll(select: NgModel) {
    select.update.emit([]);
    this.emitFilter();
  }

  showDataMin(event) {
    this.dataMinLabel = this.rangeDays[event.value - 1];
  }

  showDataMax(event) {
    this.dataMaxLabel = this.rangeDays[event.value - 1];
  }


  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.dataInicial && changes.dataInicial.currentValue &&
      changes.dataFinal && changes.dataFinal.currentValue) {
      this.calcSliderRange(this.dataInicial, changes.dataFinal.currentValue);
    }
  }
}
